/******************************************************************************************

_                      _             
(_) _ __   ____  _ _   (_) _ __  __ _ 
| |( '_ '\/ ,__)( '_'\ | |( '__)/'_' )
| || | ) )\__, \| (_) )| || |  ( (_| |
(_)(_) (_)(____/|  __/ (_)(_)   \__,_)
| |                   
(_)                   

Inspira Digital Alterations - General Script
=============================================


******************************************************************************************/

console.log('%cinspira digital', 'font-size:28px;font-weight:bold;color:#009ee2;text-shadow:0 1px 0 #ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 10px 10px rgba(0,0,0,.15);');
console.log('%cmaking sense of the web since 2008','font-size:12.3px;color:#aaa;padding-left: 1.9px;');

$(function() {
var tyreSearchForm = null,
typeElement = null,
widthElement = null,
profileElement = null,
diameterElement = null,
speedElement = null,
loadElement = null;

function init() {
deviceDecider();

if ($('body.large #home-banner').length) {
$('body #home-banner').height($('body .tyre-search').height());
} else { $('body #home-banner').height(281); }
}
function deviceDecider() {
var small = 480;
var medium = 768;
var large = 769;

var windowWidth = $(window).width();
var body = $('body');

if (windowWidth >= large) {
body.addClass('large');
body.removeClass('medium');
} else if (windowWidth > small && windowWidth <= medium) {
body.removeClass('large');
body.addClass('medium');
body.removeClass('small');
} else if (windowWidth <= small) {
body.removeClass('medium');
body.addClass('small');
}
}
function findActiveFilters() {
var somethingAdded = false,
activeFilters = '';

$('.filter-tags select')
.each(function(){
if ($(this).val() != '') {
if (somethingAdded == true) activeFilters += ', ';
activeFilters += $(this).val();
somethingAdded = true;
}
});

if (activeFilters != '') $('.active-filters span').text(activeFilters);
}
function initTyreSearch(element) {
tyreSearchForm = $(element).closest('.tyre-search');

grabTyreSearchElements();
}
function grabTyreSearchElements() {
typeElement = $(tyreSearchForm).find('select[name="type"]');
widthElement = $(tyreSearchForm).find('select[name="width"]');
profileElement = $(tyreSearchForm).find('select[name="profile"]');
diameterElement = $(tyreSearchForm).find('select[name="diameter"]');
speedElement = $(tyreSearchForm).find('select[name="speed"]');
loadElement = $(tyreSearchForm).find('select[name="load"]');
}
function validateTyreSearchFields() {
var valid = true;

if (typeElement.val() == '') valid = false;
if (widthElement.val() == '') valid = false;
if (profileElement.val() == '') valid = false;
if (diameterElement.val() == '') valid = false;
if (speedElement.val() == '') valid = false;
if (loadElement.val() == '') valid = false;

return valid;
}
function addError(element) { $(element).addClass('error'); }
function removeError(element) { $(element).removeClass('error'); }
function highlightTyreSearchFields() {
if (typeElement.val() == '') {addError(typeElement.prev('label'));}else{removeError(typeElement.prev('label'));}
if (widthElement.val() == '') {addError(widthElement.prev('label'));}else{removeError(widthElement.prev('label'));}
if (profileElement.val() == '') {addError(profileElement.prev('label'));}else{removeError(profileElement.prev('label'));}
if (diameterElement.val() == '') {addError(diameterElement.prev('label'));}else{removeError(diameterElement.prev('label'));}
if (speedElement.val() == '') {addError(speedElement.prev('label'));}else{removeError(speedElement.prev('label'));}
if (loadElement.val() == '') {addError(loadElement.prev('label'));}else{removeError(loadElement.prev('label'));}
}

$(document)
.ready(function() {
init();

$('#requested-date').datepicker({
minDate: 2,
dateFormat: "dd/mm/yy"
});

if ($('.tooltip').length) {
$('.tooltip span')
.each(function(){
var elementWidth = $(this).parent().width() / 2;

$(this).css( 'left' , elementWidth );

var tooltipWidth = $(this).outerWidth();
var calloutWidth = $(this).find('.callout').outerWidth();
var pos = (((tooltipWidth - calloutWidth) / tooltipWidth) * 100) / 2;

$(this).find('.callout').css( 'left' , pos + '%' );
});
}

if ($('body.template-index, body.template-collection').length) {
$('#filter-types-select')
.prepend($('[value="/collections/car"]'));

$('#filter-width-select')
.append($('.width_1'))
.append($('.width_2'))
.append($('.width_3'))
.prepend($('[value="width-7-5"]'))
.prepend($('[value="width-4"]'))
.prepend($('[value="width-2"]'));

$('#filter-profile-select')
.prepend($('[value="profile-9-5"]'))
.prepend($('[value="profile-8-5"]'))
.prepend($('[value="profile-0"]'))
.append($('.profile_null'));

$('#filter-diameter-select')
.prepend($('[value="diameter-8"]'))
.prepend($('[value="diameter-4"]'));

if($('#filter-speed-select').length) {
(function() {
var $select = $('#filter-speed-select');

if(!$select.find('option[value="speed-h"]').length) {
return false
}

var $option = $select.find('option[value="speed-h"]');

if($select.find('option[value="speed-u"]').length) {
$option.insertAfter($select.find('option[value="speed-u"]'));
}
else if($select.find('option[value="speed-v"]').length) {
$option.insertBefore($select.find('option[value="speed-v"]'));
}
})();
}
$('#filter-speed-select')
.find('option[value="speed-null"]').remove();

$('#filter-load-select')
.prepend($('.load_first_half'))
.prepend($('[value="load"]'));
/*
if($('#filter-radial-select').length) {
(function() {
var $select = $('#filter-radial-select');

if(!$select.find('option[value="radial-null"]').length) {
return false
}

var $option = $select.find('option[value="radial-null"]');

if($select.find('option[value="radial-zr"]').length) {
$option.insertAfter($select.find('option[value="radial-zr"]'));
}
})();
}
*/
$('#filter-season-select')
.prepend($('[value="season-w"]'))
.prepend($('[value="season-s"]'));

$('#tyre-search select')
.each(function(){
$(this).prepend($(this).find('.default-filter'));
});

$('.collection-sidebar ul, .collection-sidebar select')
.each(function(){
//$(this).prepend($(this).find('.active-filter'));
$(this).val($(this).find('.active-filter').val());
$(this).prepend($(this).find('.default-filter'));
});

findActiveFilters();
/*
$('.expandable')
.each(function(){
if ($(this).find('ul li').size() <= 10) {
$(this).removeClass('expandable');
}
});
*/
}
/*
$('.accordion-toggle')
.click(function(){
if ($(this).siblings('ul').hasClass('expanded')) {
$(this).html('Expand &#x25BC;').siblings('ul').slideUp().css('height','100px').removeClass('expanded');
} else {
$(this).html('Collapse &#x25B2;').siblings('ul').css('height','100%').slideDown().addClass('expanded');
}
});
*/
$('.search-bar input[name="q"]')
.focus(function(){
$(this).parent('.tooltip').addClass('hover');
})
.blur(function(){
$(this).parent('.tooltip').removeClass('hover');
});

$('body.template-index .tyre-search-submit')
.hover(function(){
initTyreSearch($(this));

var valid = validateTyreSearchFields();

if (valid) {
var url = typeElement.val() + '/';
var isFirst = true;

if (widthElement.val() != 'unknown') url += widthElement.val(), isFirst = false;
if (!isFirst && profileElement.val() != 'unknown') url += '+';
if (profileElement.val() != 'unknown') url += profileElement.val(), isFirst = false;
if (!isFirst && diameterElement.val() != 'unknown') url += '+';
if (diameterElement.val() != 'unknown') url += diameterElement.val(), isFirst = false;
if (!isFirst && speedElement.val() != 'unknown') url += '+';
if (speedElement.val() != 'unknown') url += speedElement.val(), isFirst = false;
if (!isFirst && loadElement.val() != 'unknown') url += '+';
if (loadElement.val() != 'unknown') url += loadElement.val();

$(this).prop('href', url);
} else { $(this).prop('href','') }
})
.click(function(e){
initTyreSearch($(this));

if ($(this).prop('href') == window.location || $(this).prop('href') == '#' || $(this).prop('href') == '') {
e.preventDefault(), highlightTyreSearchFields();
}
});

$('.filters-dropdown-trigger')
.click(function(){
if ( $('body.medium').length || $('body.small').length ) {
if ($(this).siblings('.filters-dropdown').hasClass('expanded')) {
$(this).siblings('.filters-dropdown').slideUp().removeClass('expanded');
$(this).find('span').html('&#x25BC;')
} else {
$(this).siblings('.filters-dropdown').slideDown().addClass('expanded');
$(this).find('span').html('&#x25B2;');
}
}
});

/*$('#filter-types select')
.change(function(){
var windowLocation = $(this).val();

window.location = windowLocation;
});*/

$('#filter-brands select')
.change(function(){
var windowLocation = $('.collection-sidebar').data('collection-url');
if ($(this).val() != '') windowLocation = '/collections/vendors?q='+$(this).val();
if (windowLocation == '/') windowLocation = '/collections/all/';

window.location = windowLocation;
});

/*$('body.template-collection .filter-select')
.change(function(){
var somethingAdded = false,
windowLocation = $('.collection-sidebar').data('collection-url');
if (windowLocation == '/') windowLocation = '/collections/all/';

if ($(this).val() != '') windowLocation += $(this).val(), somethingAdded = true;

$(this).parent('.filter-tags').siblings('.filter-tags').find('.filter-select').each(function(){
if ($(this).val() != '') {
if (somethingAdded == true) windowLocation += '+';
windowLocation += $(this).val();
somethingAdded = true;
}
});

window.location = windowLocation;
});*/
$('body.template-collection .tyre-filter-submit')
.click(function(e){
e.preventDefault();
/*var somethingAdded = false,
windowLocation = $('.collection-sidebar').data('collection-url');*/
var somethingAdded = false,
windowLocation = $('#filter-types select').val() + '/';
if (windowLocation == '/') windowLocation = '/collections/all/';

$('.filter-select').each(function(){
if ($(this).val() != '') {
if (somethingAdded == true) windowLocation += '+';
windowLocation += $(this).val();
somethingAdded = true;
}
});

window.location = windowLocation;
});
});

/*$('body.template-collection .tyre-filter-reset')
.click(function(e){
e.preventDefault();
$('.filter-select').each(function(){
$(this).prop('selectedIndex',0);
});
$('#filter-types-select').prop('selectedIndex',0);
$([document.documentElement, document.body]).animate({
scrollTop: $("#filter-title").offset().top
}, 1200);
});*/

$(window)
.resize(function(){
init();

// Make sure the filters are show for desktop
if ($('body.large.template-collection').length || $('body.large.template-search').length) {
if ($('.filters-dropdown:hidden')) $('.filters-dropdown').fadeIn()
.promise()
.done(function(){
$(this).css('display','');
});
}
});

});